import type { FaireProductEntity } from "../../entity_types/product";

export const p_z98923pkjf: FaireProductEntity = {
  token: "p_z98923pkjf",
  type: "product",
  name: "***Sale*** Noel Tee (2S-2M-1L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/6363864eb60353011d18fb66e58180b21b017a8d65e56baebf26fe978e84839d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d571766fe94aba6f49e464c0aea7b888e085cca2e465cd75aae6a96cc2908a21.jpeg",
    "https://cdn.faire.com/fastly/f746d814255a90ceb87ef55075a58175b55918e28f9c659e140dfcf1a320f5ee.jpeg",
    "https://cdn.faire.com/fastly/1060f249c9d68d5afcb5850aac67877d287fca11c934a316fdca50f2bb6224cc.jpeg",
    "https://cdn.faire.com/fastly/646504e26c08b1746622f94267385a6b2edc6e7ec21b9b0b0ad0df72454c92c4.jpeg",
    "https://cdn.faire.com/fastly/e8e0f7d13742c747a00997725216d547744009246ae8643705a10267df0da0e0.jpeg",
  ],
  priceDollars: 140,
  description:
    '𝐖𝐡𝐲 𝐖𝐞 𝐌𝐚𝐝𝐞 𝐓𝐡𝐢𝐬?\n\nSoft, classic, and everything you want in an everyday essential. The Noel Tee features timeless t-shirt details like a clean, crew neckline and short sleeves. Made from ultra-soft cotton with a perfectly balanced weight, it never feels too thick or too thin. The length is designed to pair effortlessly with mid-rise or lower-waist bottoms.\n*Due to the nature of the washing and production process, the actual fit of each tee may run slightly larger or smaller than the size indicated on the label. Each tee is unique, and these natural differences do not affect wearability. All sales are final.\n\nMade in Los Angeles, USA\n\nPlease note: The dyeing and washing process gives each garment unique character. Please allow for slight color and fit variation for each garment.\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n100% Cotton\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\nDue to the nature of pigment dyeing and distressing, loose pigments may remain on the garment\'s surface, giving each piece a unique character. Please allow for slight variations in color, fit, and distressed details for each garment.\n• Do not spot clean\n• Washing these garments only with like colors and in cold water\n• Hang Dry\n\n𝐀𝐩𝐩𝐫𝐨𝐱𝐢𝐦𝐚𝐭𝐞 𝐌𝐞𝐚𝐬𝐮𝐫𝐞𝐦𝐞𝐧𝐭𝐬:\nLength: 20"(S), 21"(M), 22"(L)\nChest: 17 3/4"(S), 18 3/4"(M), 19 3/4"(L)\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size Small\n\n𝐌𝐒𝐑𝐏:\n$59 USD',
  tags: [],
  msrpDollars: 280,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:04.990Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
